import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Tag = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.6876 44.5834C28.889 45.382 27.8994 45.7813 26.7188 45.7813C25.5383 45.7813 24.5487 45.382 23.7501 44.5834L5.41675 26.2501C5.0348 25.8681 4.73098 25.4167 4.50529 24.8959C4.2796 24.3751 4.16675 23.8195 4.16675 23.2292V8.33342C4.16675 7.18758 4.57473 6.20668 5.39071 5.39071C6.20668 4.57473 7.18758 4.16675 8.33342 4.16675H23.2292C23.8195 4.16675 24.3751 4.2796 24.8959 4.50529C25.4167 4.73098 25.8681 5.0348 26.2501 5.41675L44.5834 23.8022C45.382 24.6008 45.7813 25.5817 45.7813 26.7449C45.7813 27.9081 45.382 28.889 44.5834 29.6876L29.6876 44.5834ZM26.7188 41.6668L41.6147 26.7709L23.2292 8.33342H8.33342V23.2292L26.7188 41.6668ZM13.5417 16.6667C14.4098 16.6667 15.1477 16.3629 15.7553 15.7553C16.3629 15.1477 16.6667 14.4098 16.6667 13.5417C16.6667 12.6737 16.3629 11.9358 15.7553 11.3282C15.1477 10.7206 14.4098 10.4167 13.5417 10.4167C12.6737 10.4167 11.9358 10.7206 11.3282 11.3282C10.7206 11.9358 10.4167 12.6737 10.4167 13.5417C10.4167 14.4098 10.7206 15.1477 11.3282 15.7553C11.9358 16.3629 12.6737 16.6667 13.5417 16.6667Z"
        fill={color}
      />
    </svg>
  )
}
